<template>
  <Main>
    <ToolsPanel :breadCrumbFirst="$t('nav.teams')" :title="$t('team.listTitle')">
      <div class="list__buttons">
        <MainButton @click.native="handleCreate()">Create</MainButton>
      </div>
    </ToolsPanel>
    <ContentContainer>
      <div class="list__filter">
        <div class="list__filter-item ids">
          <input type="text" v-model="filterData.name" placeholder="Name" />
        </div>

        <div class="list__filter-button">
          <MainButton @click.native="filterList()">Filter</MainButton>
        </div>
        <div class="list__filter-button">
          <MainButton @click.native="filterListReset()">Reset</MainButton>
        </div>
      </div>

      <div class="list">
        <div v-if="teamsList.length">
          <CustomTable
            v-if="teamsList.length"
            :data="teamsList"
            :deleted-keys="tableOptions.deletedKeys"
            :rename-columns="tableOptions.renameColumn"
            :custom-order="tableOptions.customOrder"
            :is-action-block-visible="tableOptions.isActionBlockVisible"
            :handle-delete="admin ? handleDelete : false"
            :handleFilter="handleFilter"
            :handle-edit="handleEdit"
            :handle-copy="handleDetail"
            :direction="directionSort"
            :order="orderSort"
            :noSortColumn="tableOptions.noSortColumn"
            :name="'teams'"
          >
          </CustomTable>
          <div class="pagination">
            <Pagination
              :maxPage="teams.lastPage"
              :page="page"
              :urlList="'TEAM_LIST'"
              :totalItem="teams.total"
            />
          </div>
        </div>
        <div class="list__no-have" v-else>No teams found by this parameter.</div>
      </div>
    </ContentContainer>

    <ModalError
      :error-modal="false"
      :handle-close-error-modal="
        () => {
          this.error = {};
        }
      "
    />

    <MainModal v-if="deleteModal" :on-close="handleCloseConfirmModal" :modal-center="true">
      <div class="list__confirm">
        <div class="list__confirm-title">
          Do you want to delete the Team - {{ deleteRow.name }}?
        </div>
        <div class="list__confirm-buttons">
          <div class="list__confirm-button">
            <MainButton buttonWhite @click.native="handleCloseConfirmModal">CANCEL</MainButton>
          </div>
          <div class="list__confirm-button">
            <MainButton @click.native="handleDeleteRow" :button-cancel="true">DELETE</MainButton>
          </div>
        </div>
      </div>
    </MainModal>

    <MainModal v-if="detailModal" :on-close="handleCloseDetailModal" :modal-center="true">
      <div class="list__confirm">
        <div class="list__confirm-column">
          <div class="list__confirm-title">Detail</div>
        </div>

        <div class="list__confirm-column">
          <div class="list__confirm-title">Log List</div>
        </div>
      </div>
    </MainModal>

    <MainModal v-if="deleteModalSuccess" :on-close="handleCloseSuccessModal">
      <div class="list__success-delete">Team {{ deleteRow.name }} successfully deleted.</div>
    </MainModal>
    <FetchSpinnerModal v-if="loadingProcess" />
  </Main>
</template>

<script>
import { mapState } from "vuex";
import ROUTE from "~/constants/routes";
import userApi from "~/api/user";
import moment from "moment";
import { getStoredUserInfo } from "~/helpers/userAuth";

import Main from "~/templates/Main.vue";
import FetchSpinnerModal from "~/components/molecules/FetchSpinnerModal.vue";
import ToolsPanel from "~/components/molecules/ToolsPanel.vue";
import ContentContainer from "~/components/molecules/ContentContainer.vue";
import MainButton from "~/components/atoms/buttons/MainButton.vue";
import CustomTable from "~/components/molecules/CustomTable.vue";
import Pagination from "~/components/molecules/Pagination.vue";
import MainModal from "~/components/molecules/MainModal.vue";
import ModalError from "~/components/molecules/ModalError.vue";

export default {
  name: "TeamsList",
  metaInfo: {
    title: "Teams List",
  },
  data() {
    return {
      deleteModal: false,
      deleteRow: null,
      deleteModalSuccess: false,
      directionSort: false,
      orderSort: "id",

      detailModal: false,
      chosenLead: null,

      filterData: {
        name: "",
      },
      isFilter: false,

      tableOptions: {
        deletedKeys: ["null"],
        noSortColumn: [],
        isActionBlockVisible: true,
        renameColumn: [
          {
            from: "id",
            to: "ID",
          },
          {
            from: "name",
            to: "Name",
          },
        ],
        customOrder: ["id", "name", "lead", "null"],
      },

      admin: false,
      team_lead: false,
      bayer: false,
    };
  },
  components: {
    Main,
    FetchSpinnerModal,
    ToolsPanel,
    ContentContainer,
    MainButton,
    CustomTable,
    Pagination,
    MainModal,
    ModalError,
  },
  mounted() {
    if (getStoredUserInfo()) {
      this.user = getStoredUserInfo();
      if (
        this.user.groups[0].id == 2 ||
        this.user.groups[0].id == 6 ||
        this.user.groups[0].id == 5
      ) {
        this.admin = true;
      } else if (this.user.groups[0].id == 4) {
        this.team_lead = true;
      } else if (this.user.groups[0].id == 3) {
        this.bayer = true;
      }
    }
    this.getList();
  },
  watch: {
    $route(to, from) {
      this.getList();
    },
  },
  computed: {
    ...mapState("users", ["error", "loadingProcess", "teams", "teamsList"]),
    page() {
      return +this.$route.params.page;
    },
  },
  methods: {
    formatDate(date) {
      return moment(date).format("DD.MM.YYYY HH:mm");
    },
    getList() {
      let url = `?page=${this.page}&perPage=20`;
      if (this.orderSort.length) {
        url =
          url +
          `&sortField=${this.orderSort}&sortDest=${
            this.directionSort ? "asc" : "desc"
          }&with[]=lead`;
      }

      if (this.isFilter) {
        const data = {
          parameters: {},
        };

        if (this.filterData.name.length) {
          data.parameters.name = this.filterData.name;
        }

        userApi
          .getTeamListFilter(url, data)
          .then((res) => {
            this.$store.commit("users/setLoading", false);
            console.log(res);
            const teams = res.data?.data || [];
            for (let i = 0; teams.length > i; i++) {
              teams[i].lead = teams[i]?.lead?.name;
            }

            this.$store.commit("users/setTeamsList", teams);
            this.$store.commit("users/setTeams", res.data);
          })
          .catch((error) => {
            console.log(error);
            this.$store.commit("users/setLoading", false);
            this.isFilter = false;
            this.getList();
          });
      } else {
        this.$store.dispatch("users/getTeamList", url);
      }
    },

    filterList() {
      this.isFilter = true;
      if (this.page > 1) {
        this.$router.push({
          path: ROUTE.TEAM_LIST.replace(":page", 1),
        });
      } else {
        this.getList();
      }
    },
    filterListReset() {
      this.isFilter = false;
      this.getList();
      this.filterData.name = "";
    },
    handleFilter(column) {
      this.orderSort = column;
      if (this.directionSort === null) {
        this.directionSort = true;
      } else {
        this.directionSort = !this.directionSort;
      }
      this.getList();
    },
    handleCreate() {
      this.$router.push({
        path: ROUTE.TEAM_CREATE,
      });
    },
    handleDelete(row) {
      this.deleteModal = true;
      this.deleteRow = row;
    },
    handleEdit(row) {
      this.$router.push({
        path: ROUTE.TEAM_EDIT.replace(":id", `${row.id}`),
      });
    },
    handleDetail(row) {
      this.$router.push({
        path: ROUTE.TEAM_DETAIL.replace(":id", row.id).replace(":page", 1),
      });
    },

    handleCloseConfirmModal() {
      this.deleteModal = false;
    },
    handleDeleteRow() {
      const url = `/${this.deleteRow.id}`;
      this.$store.commit("users/setLoading", true);
      userApi
        .deleteTeam(url)
        .then((res) => {
          this.$store.commit("users/setLoading", false);
          if (res.success) {
            this.getList();
            this.handleCloseConfirmModal();
            this.deleteModalSuccess = true;
          }
        })
        .catch((error) => {
          this.$store.commit("users/setLoading", false);
          console.log(error);
        });
    },
    handleCloseSuccessModal() {
      this.deleteModalSuccess = false;
    },
    closeModal() {
      this.error = null;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.custom-table__header,
/deep/.custom-table__row {
  grid-template-columns: 0.4fr 1fr 1fr 0.3fr !important;
}

.list {
  &__filter {
    padding: 10px 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  &__filter-item {
    width: 150px;
    margin-right: 10px;
    padding-bottom: 10px;
    display: flex;
    align-items: center;

    &.id {
      width: 100px;
    }

    input {
      padding: 5px 10px;
      font-size: 14px;
      width: 100%;
      height: 40px;
    }
  }

  &__filter-button {
    width: 100px;
    margin-right: 10px;
    padding-bottom: 10px;
  }

  &__modal-log-detail-button {
    padding: 10px 0;
    font-weight: 700;
    cursor: pointer;
  }

  &__modal-log-detail {
    background: rgb(39, 39, 39);
    border-radius: 5px;
    padding: 10px;
    color: #fff;
    overflow-y: auto;
  }
}
</style>
